import { join } from "ramda";

const joinPath = join("/");
const poolBaseUrl = new URL("pool", window.location.href).href;

export default function generateTeacherMaterialGetters(material) {
  const materialBaseUrl = joinPath([poolBaseUrl, material._id]);
  const bookviewerUrl = joinPath([materialBaseUrl, "bookviewer"]);
  const cacheHash = material.cachehash;
  const queryHash = cacheHash ? `?cachehash=${cacheHash}` : "";

  function getListThumbnailPath() {
    return joinPath([materialBaseUrl, `listThumbnail${queryHash}`]);
  }

  function getStaticFilePath(file) {
    return joinPath([materialBaseUrl, "static", `${file}${queryHash}`]);
  }

  function getDownloadFilePath(file) {
    return joinPath([materialBaseUrl, "download", `${file}${queryHash}`]);
  }

  function getViewerListingPath() {
    return bookviewerUrl;
  }

  // thumbnails start by 0
  function getThumbnailPath(page) {
    return `${getThumbnailPrefix()}/${page - 1}.jpg${queryHash}`;
  }

  // cache hash for images necessary
  function getImagePath(page, scale) {
    return `${getImagePrefix(scale)}${page}.jpg${queryHash}`;
  }

  // ###########################################################################
  // # Private Prefix Generation Functions
  // ###########################################################################
  function getThumbnailPrefix() {
    return joinPath([bookviewerUrl, "thumbs"]);
  }

  function getImagePrefix(scale) {
    let prefix = "ps_";

    if (scale > 1) {
      prefix = "pl_";
    } else if (scale > 0.5) {
      prefix = "p_";
    }

    return joinPath([bookviewerUrl, "imgsvg", prefix]);
  }

  return {
    getListThumbnailPath,
    getStaticFilePath,
    getDownloadFilePath,
    getViewerListingPath,
    getThumbnailPath,
    getImagePath
  };
}
